<script lang="ts">
	import { onMount } from "svelte";

	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const models = service.store.municipalities
</script>

<div class="{klass}">
	<FormWithLabel
		label="市区町村"
		input={service.handleMunicipalities}
		values={$model.municipalities}
		value={$model.municipalities[0]}
		inputType="select"
		options={$models}
	/>
</div>